import styles from "styles/pages/cdp/database-management.module.scss";

import classNames from "classnames/bind";
import { Icon } from "shared/components/core/Icon";
const css = classNames.bind(styles);

export default function Folder({ folder, onSelectFolder }) {
  const isIgnored = folder?.name === "Ignorados" || false;

  return (
    <div
      className={css({ folder: true, ignored: isIgnored })}
      onClick={() => onSelectFolder(folder.id)}
    >
      <div className={styles.icon}>
        {isIgnored ? (
          <Icon name="fa-ban" light />
        ) : (
          <Icon name="fa-layer-group" light />
        )}
      </div>
      <div className="d-flex align-center justify-between">
        <p className={styles.name}>{folder.name}</p>
        <span className={styles.quantity}>{folder.quantity || 0}</span>
      </div>
    </div>
  );
}
